export default __webpack_public_path__ + "static/media/480_business05-jp-web.fb3469cd.png";